import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=bd09a39c&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=bd09a39c&prod&scoped=true&lang=css"
import style1 from "./ProductList.vue?vue&type=style&index=1&id=bd09a39c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd09a39c",
  null
  
)

export default component.exports